import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ProductCatalog } from '../../../models/product-catalog.model';
import { Product } from '../../../models/product.model';
import { Order } from '../../../models/order.model';

@Component({
  selector: 'app-carousel-item',
  templateUrl: './carousel-item.component.html',
  styleUrls: ['./carousel-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CarouselItemComponent implements OnInit {
  @Input() item: Product | ProductCatalog;
  @Input() order: Order;

  constructor() {}

  ngOnInit(): void {}

  get isProgram(): boolean {
    return this.item instanceof ProductCatalog;
  }

  get programLabel(): string {
    return this.item?.label || '';
  }

  get programUrl(): string {
    return (this.item as ProductCatalog)?.programDetailsUrl;
  }

  get featuredProgram(): boolean {
    // return (this.item as ProductCatalog).isFeatureType;
    return true;
  }

  get programImage(): string {
    const image = (this.item as ProductCatalog).getImage();
    return image && image['url']
      ? image['url']
      : '/assets/img/app/no-image.png';
    // return (this.item as ProductCatalog).getImage()['url'] ;
  }

  get backgroundImage() {
    return { 'background-image': `url(${this.programImage})` };
  }

  get product(): Product {
    if (this.item && this.item instanceof Product) {
      return this.item as Product;
    }
  }
}
